<div class="mx-auto w-full max-w-[480px]">
  <dojo-selection-list
    class="swiper-detail-view"
    (optionSelected)="optionSelected.emit($event)"
    [formCtrl]="formCtrl"
    [options]="options"
    [multiple]="false"
    [labelsAreTranslationKeys]="true"
    [figureIconSize]="35"
  />
</div>
